import { Checkbox } from 'antd';

import { computeExperienceName } from 'app/components/commons/Experience/utils';
import { RedirectLink } from 'app/components/commons/RedirectLink/RedirectLink';
import { CoverCellRoom } from 'app/components/lists/cells';
import { useExperiencesCategories } from 'app/hooks/data/useExperience';
import type { ExperienceResponse } from 'app/typings/core/admin/experiences/experience';
import { capitalizeFirstLetter } from 'app/utils/string';

import './AddExperiencesModal.scss';

type ExperienceListItemProps = {
  experience: ExperienceResponse;
  selected: boolean;
  onToggle: (id: number, checked: boolean) => void;
  categoryName?: string;
};

export const ExperienceListItem = ({
  experience,
  selected,
  onToggle,
  categoryName,
}: ExperienceListItemProps) => {
  const { data: experienceCategories } = useExperiencesCategories();

  const experienceName = computeExperienceName({
    category: experienceCategories?.find(
      (cat) => cat.id === experience.categoryId
    ),
    quantity: null,
    brand: experience.brand ?? null,
    duration: experience.duration ?? null,
    durationDescription: experience.durationDescription ?? null,
    time: experience.time ?? null,
    locations: experience.location ?? null,
  });

  return (
    <div className="experience-list-item">
      <div className="status-and-info">
        <div className="experience-info">
          <CoverCellRoom
            category={categoryName ?? 'Experience'}
            entity={{
              coverPicture: experience.coverPicture,
              name: experienceName,
            }}
          />
        </div>
        <div className="experience-action">
          <div className="experience-status">
            <span className={`er-dot ${experience.status.toLowerCase()}`} />
            <span className="status-text">
              {capitalizeFirstLetter(experience.status)}
            </span>
          </div>
          <RedirectLink href={`/activities/${experience.id}`} />
          <Checkbox
            checked={selected}
            onChange={(e) => onToggle(experience.id, e.target.checked)}
          />
        </div>
      </div>
    </div>
  );
};
